"use strict";
/**
 * Common constants used across applications
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEST_ADS = exports.BYPASS_CACHE = void 0;
/**
 * URL parameter name used for cache busting
 */
exports.BYPASS_CACHE = 'bypassCache';
/**
 * URL parameter name used for using fake test ads
 */
exports.TEST_ADS = 'testAds';
